import React, {useEffect, useState} from 'react'
import {useHistory, useLocation} from 'react-router-dom'
import {Heading, Text, GridItem, SimpleGrid, Box, ListItem,} from '@chakra-ui/react'
import {useListProducts} from '../../core/hooks'
import {Card} from '../../components/Theme'
import HeaderForCatalogues from './HeaderForCatalogues'
import LoadingSmall from "../../components/LoadingSmall";
import './styles.css'
import Loading from "../../components/Loading";

const Products = () => {
    const location = useLocation()
    const [products, setProducts] = useState([])
    const history = useHistory()
    const [offset, setOffset] = useState(null)
    const [offsetPage, setOffsetPage] = useState(1)
    const [page, setPage] = useState(1)
    const [filter, setFilter] = useState('')
    const [search, setSearch] = useState('')
    const path = location.pathname.split('/')[2]
    const [isLoading, setIsLoading] = useState(true);
    let condition = {
        condition: {
            table: path === 'fixtures' ? 'FIXTURES' : 'LAMPS',
            filter: '',
            search,
            page,
            offset,
        }
    }
    const {data: productsResponse, isLoading: isProductLoading, refetch} = useListProducts(condition)


    useEffect(() => {
        if (!productsResponse) return
        if (page === 1){
            setProducts(productsResponse.data.data?.records ?? [])
        } else {
            setProducts((prevProducts) => [
                ...prevProducts,
                ...productsResponse.data.data?.records ?? [],
            ]);
        }
        setOffset(productsResponse.data.data?.nextOffset ?? "")
        setIsLoading(false);
    }, [productsResponse])

    const loadMoreProducts = () => {
        if (isLoading) return;
        if (page >= 2 && !offset) return
        setIsLoading(true);
        refetch()
        setPage((prevPage) => prevPage + 1);
    };

    console.log(productsResponse)
    console.log(products)
    console.log(2222222222)
    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY + window.innerHeight;
            const pageHeight = document.documentElement.scrollHeight;

            if (scrollPosition >= pageHeight * 0.5 && !isLoading) {
                loadMoreProducts();
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isLoading]);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
                setOffset(null)
                setPage(1)
                if (search.length > 2 || search.length === 0) {
                    refetch()
                }
        }, 800);

        return () => clearTimeout(delayDebounceFn);
    }, [search, refetch]);

    const handleSearch = (e) => {
        setSearch(e.target.value)
    }
    if (isProductLoading) return <Loading />

    console.log(products)
    return (
        <>
            <HeaderForCatalogues
                handleSearch={handleSearch}
                title={path}/>
            <SimpleGrid p="12" w="full" columns={{base: 1, sm: 2, md: 3, lg: 4,}} spacing="8">
                {products?.map((product, index) => (
                    <GridItem colSpan={1} onClick={() => history.push(`/catalogues/product/${path}/${product?.id}`)} key={index}>
                        <Card image={product.fields['Product Image (hyperlink)'] ? product.fields['Product Image (hyperlink)'] : ''}>
                            {/*<Heading fontSize="14px" fontFamily='Titillium Web'>{path === 'lamps' ? product.fields['FE Product Description'] : product.fields['FE Product Description']}</Heading>*/}
                            {/*<Text fontSize="12px">{product.fields['FE Product Description'] ? product.fields['FE Product Description'].replace(/(.{60})..+/, "$1…")  : ' '}</Text>*/}
                            {
                                path === 'lamps'
                                &&
                                <Heading style={{margin: 0, marginBottom: '5px'}}>
                                    <Box style={{display: 'flex',fontWeight: "bold",flexWrap: "wrap"}}>
                                        {/*<Text fontSize="14px" fontWeight={"700"} fontFamily={"Titillium Web"}>{product.fields['Style'] ? product.fields['Style'] + ',' : ' '}</Text>*/}
                                        <Text
                                            fontSize="14px"
                                            fontWeight="700"
                                            fontFamily="Titillium Web"
                                        >
                                            {[
                                                product.fields['Type'] !== '' ? `${product.fields['Type']}` : '',
                                                product.fields['Wattage'] ? `${product.fields['Wattage']}W` : '',
                                                product.fields['Lumens'] ? `${product.fields['Lumens']}L` : '',
                                                product.fields['CCT (K˚)'] ? `${product.fields['CCT (K˚)']}K` : '',
                                                product.fields['CRI'] ? `${product.fields['CRI']}CRI` : '',
                                                product.fields['Dimmability']
                                            ]
                                            .filter(Boolean)
                                            .join(', ')}
                                        </Text>
                                    </Box>
                                </Heading>
                            }
                            {
                                path === 'fixtures'
                                &&
                                <Heading style={{margin: 0, marginBottom: '5px'}}>
                                    <Box style={{display: 'flex',fontWeight: "bold",flexWrap: "wrap"}}>
                                        {/*<Text fontSize="14px" fontWeight={"700"} fontFamily={"Titillium Web"}>{product.fields['Style'] ? product.fields['Style'] + ',' : ' '}</Text>*/}
                                        {/*<Text fontSize="14px" fontWeight={"700"} fontFamily={"Titillium Web"}>{product.fields['Wattage'] !== '' ? product.fields['Wattage'] + ',' : ''}</Text>*/}
                                        {/*<Text fontSize="14px" fontWeight={"700"} fontFamily={"Titillium Web"}>{ product.fields['Lumens'] !== '' ? product.fields['Lumens'] + ',': ''}</Text>*/}
                                        {/*<Text fontSize="14px" fontWeight={"700"} fontFamily={"Titillium Web"}>{ product.fields['CCT (K˚)'] !== '' ? product.fields['CCT (K˚)'] + ',': ''}</Text>*/}
                                        {/*<Text fontSize="14px" fontWeight={"700"} fontFamily={"Titillium Web"}>{product.fields['CRI'] !== '' ? product.fields['CRI'] + ',': ''}</Text>*/}
                                        {/*<Text fontSize="14px" fontWeight={"700"} fontFamily={"Titillium Web"}>{product.fields['Dimmability'] !== '' ? product.fields['Dimmability']: ''}</Text>*/}
                                        <Text
                                            fontSize="14px"
                                            fontWeight="700"
                                            fontFamily="Titillium Web"
                                        >
                                        {[
                                            product.fields['Style'] !== '' ? `${product.fields['Style']}` : '',
                                            product.fields['Wattage'] ? `${product.fields['Wattage']}W` : '',
                                            product.fields['Lumens'] ? `${product.fields['Lumens']}L` : '',
                                            product.fields['CCT (K˚)'] ? `${product.fields['CCT (K˚)']}K` : '',
                                            product.fields['CRI'] ? `${product.fields['CRI']}CRI` : '',
                                            product.fields['Dimmability']? `${product.fields['Dimmability']}` + ' ' : ''
                                        ]
                                            .filter(Boolean)
                                            .join(', ')}
                                        </Text>
                                    </Box>
                                </Heading>
                            }
                            {
                                path === 'lamps'
                                &&
                                <Box style={{display: 'flex',flexWrap: "wrap"}}>
                                    {/*<Box display={"flex"}>*/}
                                    {/*    <Text fontSize="12px" fontFamily={"Titillium Web"}>{product.fields['Depth (inches)'] !== '' ? product.fields['Depth (inches)'] : ' '}x</Text>*/}
                                    {/*    <Text fontSize="12px" fontFamily={"Titillium Web"}>{product.fields['Diameter (inches)'] !== '' ? product.fields['Diameter (inches)'] + ',': ''} </Text>*/}
                                    {/*</Box>*/}
                                    <Text fontSize="12px" fontFamily={"Titillium Web"}>
                                        {[
                                            product.fields['Width (inches)'],
                                            product.fields['Length (inches)'],
                                            product.fields['Diameter (inches)'],
                                            // product.fields['Depth (inches)'] + ''
                                        ]
                                            .filter(v => v !== undefined && v !== '')
                                            .map(v => `${v}"`)
                                            .join('x')}
                                    </Text>
                                    {/*<Text fontSize="12px" fontFamily={"Titillium Web"}>{product.fields['Lens Type'] !== '' ? product.fields['Lens Type']  + ',': ''} </Text>*/}
                                    {/*<Text fontSize="12px" fontFamily={"Titillium Web"}>{product.fields['Beam Angle'] !== '' ? product.fields['Beam Angle']  + ',' : ''} </Text>*/}
                                    {/*<Text fontSize="12px" fontFamily={"Titillium Web"}>{product.fields['Optics'] !== '' ? product.fields['Optics'] + ',': ''}</Text>*/}
                                    {/*<Text fontSize="12px" fontFamily={"Titillium Web"}>{product.fields['Ingress Protection'] !== '' ? product.fields['Ingress Protection'] + ',': ''}</Text>*/}
                                    {/*<Text fontSize="12px" fontFamily={"Titillium Web"}>{product.fields['Color Tunable'] !== '' ? product.fields['Color Tunable'] + ',': ''}</Text>*/}
                                    {/*<Text fontSize="12px" fontFamily={"Titillium Web"}>{product.fields['L70 Lifetime (hours)'] !== '' ? product.fields['L70 Lifetime (hours)'] + ',': ''}</Text>*/}
                                    {/*<Text fontSize="12px" fontFamily={"Titillium Web"}>{product.fields['Warranty (years)'] !== '' ? product.fields['Warranty (years)']: ''}</Text>*/}
                                    <Text fontSize="12px" fontFamily={"Titillium Web"}>
                                    {[
                                        product.fields['Lens Type'] || null,
                                        product.fields['Beam Angle'] || null,
                                        product.fields['Optics'] || null,
                                        product.fields['Ingress Protection'] || null,
                                        product.fields['Color Tunable'] || null,
                                        product.fields['L70 Lifetime (hours)'] || null,
                                        product.fields['Warranty (years)'] || null
                                    ]
                                        .filter(v => v !== null && v !== '')
                                        .join(`, `)}
                                    </Text>
                                </Box>
                            }
                            {
                                path === 'fixtures'
                                &&
                                <Box style={{display: 'flex',flexWrap: "wrap"}}>
                                    <Box display={"flex"}>
                                        <Text fontSize="12px" fontFamily={"Titillium Web"}>
                                            {[
                                                product.fields['Width (inches)'],
                                                product.fields['Length (inches)'],
                                                product.fields['Diameter (inches)'],
                                                product.fields['Depth (inches)']
                                            ]
                                                .filter(v => v !== undefined && v !== '')
                                                .map(v => `${v}"`)
                                                .join('x')}
                                        </Text>
                                    </Box>
                                    <Text fontSize="12px" fontFamily={"Titillium Web"}>
                                        {[
                                            product.fields['Lens Type'] || null,
                                            product.fields['Beam Angle'] || null,
                                            product.fields['Optics'] || null,
                                            product.fields['Ingress Protection'] || null,
                                            product.fields['Color Tunable'] || null,
                                            product.fields['L70 Lifetime (hours)'] || null,
                                            product.fields['Warranty (years)'] || null
                                        ]
                                            .filter(v => v !== null && v !== '')
                                            .join(`, `)}
                                    </Text>
                                </Box>
                            }
                        </Card>
                    </GridItem>))}
            </SimpleGrid>
            {isLoading &&
                <LoadingSmall />
            }
        </>
    )
}

export default Products
